import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import EvaluationTemplateSummary from './summary/EvaluationTemplateSummary';

export default function EvaluationTemplateShow(props) {
    return <EvaluationTemplateSummary fetchUrl={fetchUrl} deleteUrl={deleteUrl} redirectUrl={redirectUrl} pdfUrl={pdfUrl} />;
}

if (document.getElementById('showEvaluationTemplate')) {
    ReactDOM.render(
        <App>
            <EvaluationTemplateShow />
        </App>,
        document.getElementById('showEvaluationTemplate'),
    );
}
